import Default from "../platforms/default/locale";
import awf from "../platforms/awf/locale";
import afr from "../platforms/afr/locale";
import zidr from "../platforms/zidr/locale";

const messages = {
  awf,
  afr,
  zidr,
  default: Default,
};

export default messages;
